import { cn, tv } from "@utils/tw"

export type FieldProps = {
  label?: string
  children: React.ReactNode
  error?: string
  help?: string
  required?: boolean
  className?: string
}

export function Field(props: FieldProps) {
  const styles = fieldStyles({
    invalid: !!props.error,
  })
  return (
    <div className={cn(styles.base(), props.className)}>
      <label className={styles.label()}>
        {props.label}
        {props.required && <span className={styles.required()}>*</span>}
      </label>
      <div>{props.children}</div>
      {props.help && <div className={styles.help()}>{props.help}</div>}
      {props.error && <div className={styles.error()}>{props.error}</div>}
    </div>
  )
}

export const fieldStyles = tv({
  slots: {
    base: "flex flex-col w-full gap-2",
    label: "type-label-m",
    help: "type-body-xs",
    error: "type-error-s text-red",
    required: "text-red",
  },
  variants: {
    invalid: {
      true: {
        base: "has-error",
        label: "text-red",
      },
    },
  },
})
